import { LoggerProvider } from '@wkda/logger-core';
import { mapLogLevel } from './utils';
export class CFELoggerProvider extends LoggerProvider {
  _loggerAPIService;
  constructor(logFormatter, loggerAPIService) {
    super(logFormatter);
    this._loggerAPIService = loggerAPIService;
  }
  getLogger(loggerName) {
    return {
      log: logRecord => {
        this._loggerAPIService.post({
          level: mapLogLevel(logRecord.logLevel ?? 'INFO'),
          appName: logRecord.meta?.appName,
          appVersion: logRecord.meta?.appVersion,
          stepName: logRecord.meta?.stepName,
          payload: {
            type: logRecord.logger,
            message: logRecord.message,
            stack: logRecord.error?.stackTrace
          }
        });
      },
      name: loggerName
    };
  }
}